import React from 'react'
import PropTypes from 'prop-types'

import ViewerContainer from 'Pods/Shared/Viewer/ViewerContainer'

function CategoriesViewer({ uid }) {
  return (
    <ViewerContainer uid={uid} />
  )
}

CategoriesViewer.propTypes = {
  uid: PropTypes.string.isRequired,
}

export default CategoriesViewer
